export default __webpack_public_path__ + "static/media/audience-icon-black.dc9de367.svg";